import { render, staticRenderFns } from "./PaymentGateway.vue?vue&type=template&id=248ca6b6&scoped=true"
import script from "./PaymentGateway.vue?vue&type=script&lang=js"
export * from "./PaymentGateway.vue?vue&type=script&lang=js"
import style0 from "./PaymentGateway.vue?vue&type=style&index=0&id=248ca6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248ca6b6",
  null
  
)

export default component.exports